import { Component, OnInit } from '@angular/core';
import { PostnewJob } from '../../services/job-section.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Router } from '@angular/router';
import { id } from '@swimlane/ngx-charts';
import { JobDetailsPreviewComponent } from '../job-details-preview/job-details-preview.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-applied-jobs-listing',
  templateUrl: './applied-jobs-listing.component.html',
  styleUrls: ['./applied-jobs-listing.component.scss'],
})
export class AppliedJobsListingComponent implements OnInit {

  constructor(private jobService: PostnewJob, private loginService: LoginService, private router: Router, private dialog: MatDialog,) { }
  loginDetails: any;
  applicants: any;
  openAccordionId: string | null = null;
  newMessage: string = '';
  EditedMessageId: string = '';
  displayMessage: any[] = [];

  loaderMessage = true;
  dataLoader = true;
  subscriptionRef: Subscription | null = null;


  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();

    this.loadMoreAppliedJobs();
  }

  appliedJobs: any[] = [];

  limit = 10;
  offset = 0;
  loading = false;
  endOfData = false;

  loadMoreAppliedJobs(): void {
    if (this.loading || this.endOfData) return;

    this.loading = true;

    this.jobService.getMyAppliedJobs(this.limit, this.offset).subscribe({
      next: (jobs) => {
        const enrichedJobs = jobs;
        if (enrichedJobs.length < this.limit) {
          this.endOfData = true;
        }

        this.appliedJobs = [...this.appliedJobs, ...enrichedJobs];
        this.dataLoader = false

        this.offset += this.limit;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching jobs:', err);
        this.loading = false;
        this.dataLoader = false
      },
    });
  }

  // viewJob(job: any): void {
  //   this.router.navigate(['/jobseek/jobdetails', job.id]);
  // }

  viewJob(jobId: string | number): void {

    this.dialog.open(JobDetailsPreviewComponent, {
      width: '60%',
      panelClass: ['custom-modal'],
      data: { id: jobId }   // send only the id
    });
  }

  ngOnDestroy() {
    this.subscriptionRef?.unsubscribe();
  }

  // Accordion
  toggleAccordion(job: any): void {
    const jobId = job.id;

    // If already open, close it
    if (this.openAccordionId === jobId) {
      this.openAccordionId = null;
      this.displayMessage = [];
      this.subscriptionRef?.unsubscribe();
      return;
    }

    this.openAccordionId = jobId;
    this.loaderMessage = true;

    this.newMessage = ''; // Clear the input box
    this.displayMessage = [];
    this.subscriptionRef?.unsubscribe();

    this.subscriptionRef = this.jobService.getApplicantMessage(jobId, job?.job_enquiries_find?.id)
      .subscribe({
        next: (data) => {
          // overwrite with this job’s messages only
          this.displayMessage = data;

          this.loaderMessage = false;
        },
        error: () => {
          this.loaderMessage = false;
        },
      });
  }

  // getAllMessage(ApplicantId: any, EnquiryId: any) {
  //   this.jobService.getApplicantMessage(ApplicantId, EnquiryId).subscribe({
  //     next: (data) => {
  //       const existingIds = this.displayMessage.map((m) => m.id);
  //       console.log('exi tiddd dd d d ', existingIds);

  //       const newOnes = data.filter((m: any) => existingIds.includes(m.id));
  //       this.displayMessage = [...this.displayMessage, ...newOnes];

  //       // this.displayMessage = data;
  //       console.log('displayMessage>>>>', this.displayMessage);

  //       this.loaderMessage = false;
  //     },
  //     error: () => {
  //       this.loaderMessage = false;
  //     },
  //   });
  // }

  sendMessage(jobId: any): void {
    if (!this.newMessage.trim()) return; // Do not send empty messages

    // Find the job and add the message
    const messages = {
      message: this.newMessage,
      message_from: this.loginDetails.id,
      job_applicant_id: jobId.id,
    };

    this.jobService.addApplicantMessage(messages);
    this.newMessage = ''; // Clear the input box
  }

  deleteMessage(messageId: string): void {
    this.jobService
      .deleteApplicantMessage(messageId)
      .then(() => { })
      .catch((err) => {
        console.error('Error deleting message:', err);
      });
  }

  editMessage(message: any): void {
    this.newMessage = message.message;
    this.EditedMessageId = message.id;
  }

  UpdateMessage(editId: any): void {
    const UpdateMessage = {
      id: editId,
      message: this.newMessage,
    };

    this.jobService
      .editApplicantMessages(UpdateMessage.id, UpdateMessage.message)
      .then(() => {
        this.EditedMessageId = '';
        this.newMessage = '';
      });
  }

  trackByJobId(index: number, job: any): string {
    return job.id;
  }

  getInitial(name: string | undefined | null): string {
    if (!name) return '';
    return name
      .split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2); // max 2 initials
  }
}
